import React, { useEffect } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Avatar,
  Grid,
  Divider,
  CircularProgress,
} from '@mui/material';
import { useApp } from '../context/AppContext';
import { useNavigate } from 'react-router-dom';

export const ProfilePage: React.FC = () => {
  const { state } = useApp();
  const navigate = useNavigate();

  // Auto-redirect caregivers to their unified profile page
  useEffect(() => {
    if (state.user?.role === 'CAREGIVER' && state.user?.id) {
      navigate(`/caretaker/${state.user.id}`, { replace: true });
    }
  }, [state.user, navigate]);

  // Show loading while redirecting caregivers
  if (state.user?.role === 'CAREGIVER') {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <CircularProgress />
        <Typography sx={{ ml: 2, mb: 2 }}>Redirecting to your profile...</Typography>
        <Button 
          variant="contained" 
          onClick={() => navigate(`/caretaker/${state.user?.id}`)}
        >
          Go to My Profile
        </Button>
      </Box>
    );
  }

  // Only show this page for patients
  return (
    <Box sx={{ maxWidth: 800, mx: 'auto' }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <Avatar
                  sx={{ width: 80, height: 80, mr: 3 }}
                >
                  {state.user?.displayName?.[0] || 'U'}
                </Avatar>
                <Box>
                  <Typography variant="h4" gutterBottom>
                    {state.user?.displayName || 'User Profile'}
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    {state.user?.email || 'No email available'}
                  </Typography>
                </Box>
              </Box>
              
              <Divider sx={{ my: 2 }} />
              
              <Typography variant="h6" gutterBottom>
                Profile Information
              </Typography>
              <Typography variant="body1" paragraph>
                User ID: {state.user?.id || 'Not available'}
              </Typography>
              <Typography variant="body1" paragraph>
                Display Name: {state.user?.displayName || 'Not set'}
              </Typography>
              <Typography variant="body1" paragraph>
                Email: {state.user?.email || 'Not available'}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Account Actions
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <Button 
                  variant="contained" 
                  color="primary"
                  onClick={() => {
                    alert('Patient profile editing coming soon!');
                  }}
                >
                  Edit Profile
                </Button>
                <Button variant="outlined" color="secondary">
                  Change Password
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => navigate('/settings')}
                >
                  Settings
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};
